const docType = [
  { value: 'airManifest', description: 'Air Manifest' },
  { value: 'oceanManifest', description: 'Ocean Manifest' },
  { value: 'railManifest', description: 'Rail Manifest' },
  { value: 'truckManifest', description: 'Truck Manifest' },
  { value: 'inBond', description: 'In-Bond' },
  { value: 'importerBond', description: 'Importer Bond' },
  { value: 'manufacturerMID', description: 'Manufacturer(MID)' }
];
const outOption = [
  { value: '', description: 'Return only the most recent notification' },
  { value: '1', description: 'Return up to the last 5 notifications' },
  { value: '2', description: 'Return all available notifications' }
];
const requestForRelatedBol = [
  { value: 'Y', description: 'Yes' },
  { value: 'N', description: 'No' }
];
const query = [
  {
    name: 'queryType',
    label: 'Query Type',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'reference',
    label: 'Reference',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'status',
    label: 'Status',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'submittedTime',
    label: 'Submitted Time',
    type: 'Date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'receivedTime',
    label: 'Received Time',
    type: 'Date',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const selectDoc = [
  {
    name: 'docType',
    label: 'Document Type',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const airManifest = [
  {
    name: 'mawb',
    label: 'MAWB',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'hawb',
    label: 'HAWB',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'outOption',
    label: 'Out Option',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const oceanManifest = [
  {
    name: 'bl',
    label: 'BL(SCAC+BL)',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'requestForRelatedBol',
    label: 'Request for Related BOL',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'outOption',
    label: 'Out Option',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const railManifest = [
  {
    name: 'bl',
    label: 'BL(SCAC+BL)',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'requestForRelatedBol',
    label: 'Request for Related BOL',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'outOption',
    label: 'Out Option',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const truckManifest = [
  {
    name: 'bl',
    label: 'BL(SCAC+BL)',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'requestForRelatedBol',
    label: 'Request for Related BOL',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'outOption',
    label: 'Out Option',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '2',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const inBond = [
  {
    name: 'inBondNumber',
    label: 'In-bond Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'outOption',
    label: 'Out Option',
    type: 'auto description',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const importerBond = [
  {
    name: 'importer',
    label: 'Importer',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const manufacturerMID = [
  {
    name: 'manufacturerId',
    label: 'Manufacturer ID',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
];

const responseQuery = [
  {
    name: 'referenceNumber',
    label: 'Reference Number',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'submissionType',
    label: 'Submission type',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'responseType',
    label: 'Response Type',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'submittedTime',
    label: 'Submitted Time',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'receivedTime',
    label: 'Received Time',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'submittedBy',
    label: 'Submitted By',
    type: 'text',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  },
  {
    name: 'responseText',
    label: 'Response',
    type: 'response',
    maxLength: undefined,
    placeholder: '',
    defaultValue: '',
    required: false,
    disabled: false,
    icon: undefined
  }
];
const optionsMap = {
  docType: docType,
  queryType: docType,
  outOption: outOption,
  requestForRelatedBol: requestForRelatedBol
};
export {
  query,
  selectDoc,
  airManifest,
  oceanManifest,
  railManifest,
  truckManifest,
  inBond,
  importerBond,
  manufacturerMID,
  responseQuery,
  optionsMap
};
